<template>
  <div id="add-new-order-modal">
    <v-layout row justify-center>
      <v-dialog v-model="deliveryTypeModal" persistent max-width="340px">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex xs11 sm11 md11><span class="headline">{{ $t('common.update') }}</span></v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn flat @click="closeEditDeliveryTypeModal" class="close"><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert :value="seccessAlert" type="success">
                {{ $t('customer.deliveryTypeUpdatedSuccessfully') }}
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm3 md3>
                    <v-select
                      :items="deliveryTypes"
                      item-value="value"
                      v-model="editDeliveryTypeData.delivery_type"
                      :error-messages="errors.collect('Delivery type')"
                      data-vv-name="Delivery type"
                      :label="$t('customer.deliveryType')"
                      v-validate="'required'"
                      single-line
                    >
                    </v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                id="sendButton"
                type="submit"
                style="height:auto" class="rtl-mr-20"
                outline
                color="success"
                >{{ $t('common.save') }}</v-btn
              >
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'seccessAlert',
    'deliveryTypeModal',
    'closeEditDeliveryTypeModal',
    'editDeliveryTypeData',
    'editDeliveryType',
    'deliveryTypes'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.editDeliveryType()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/editDeliveryType.vue